export const OutputHelpers = {
    props: {
        bpi: {
            type: Object,
            required: true
        },
        bpiOutPut: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatPrice(price) {
            if (price === null) return 0;
            return price?.toLocaleString("fr", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        whichMonth(month) {
            const date = new Date();
            date.setMonth(month);
            return date.toLocaleDateString("fr-fr");
        },

        groupByN(n, data) {
            let result = [];
            for (let i = 0; i < data.length; i += n)
                result.push(data.slice(i, i + n));
            return result;
        },
        isEveryNull(array, key) {
            return array.every(item => item[key] === 0);
        }
    }
};
